module.exports = __webpack_public_path__ + "/Content/img/criticalillness/CriticalIllnessPigWorried.gif";